
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { MariaDBLinkedService } from 'app/model/linkedservice/maria-db.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.mariaDB.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.MariaDB_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.MariaDB_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MariaDBLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MariaDBTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
